import React, { useState, useEffect, useRef } from "react";
import { Button } from "src/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogFooter,
} from "src/components/ui/dialog";
import { Input } from "src/components/ui/input";
import { Eye, EyeOff, CheckCircle } from "lucide-react";
import { Check } from "lucide-react";
import { Label } from "../components/ui/label"


const UpdatePasswordModal = ({ onClose }) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const confirmPasswordRef = useRef(null);
    const [showPassword, setShowPassword] = useState({
        old: false,
        new: false,
        confirm: false,
    });
    const [passwordChecks, setPasswordChecks] = useState({
        length: false,
        upperLower: false,
        specialChar: false,
        number: false,
    });
    const [showRequirements, setShowRequirements] = useState(false);
    const toggleVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };
    const handleDone = () => {
        if (!oldPassword || !newPassword || !confirmPassword) {
            alert("Please fill all fields.");
            return;
        }
        if (newPassword !== confirmPassword) {
            alert("New password and confirm password must match.");
            return;
        }

        console.log("Password changed successfully");
    };
    useEffect(() => {
        setPasswordChecks({
            length: newPassword.length >= 8,
            specialChar: /[!@#$%^&*(),_.?":{}|<>]/.test(newPassword),
            upperLower: /[a-z]/.test(newPassword) && /[A-Z]/.test(newPassword),
            number: /\d/.test(newPassword),
        });
    }, [newPassword]);
    useEffect(() => {
        if (!showRequirements) {
            confirmPasswordRef.current?.focus();
        }
    }, [showRequirements]);

    return (
        <div className="">
            <Dialog className="custom-block block" open onOpenChange={onClose}>
                {/* <DialogTrigger asChild>
                <Button variant="outline">Change Password</Button>
                </DialogTrigger> */}
                <DialogContent className="p-4 sm:p-6 bg-gray-0  max-w-full sm:max-w-[588px] responsive-mobile flex flex-col sm:flex-col justify-between sm:justify-center rounded-t-xl" closeClassname="top-5 sm:top-6 right-6 focus:ring-0 focus:ring-offset-0 opacity-100 !opacity-100 text-primary-50" closeIconClassname="w-[15.36px] h-[15.36px] text-primary-50 !text-primary-50" // Custom size & color
                >
                    <div className="flex-1">
                        <DialogHeader>
                            <DialogTitle className="text-base font-bold text-center leading-5 font-redhat">
                                Change password
                            </DialogTitle>
                        </DialogHeader>

                        <div className="space-y-5 bg-white mt-5">
                            <div className="relative w-full">
                                <Input
                                    id="old-password"
                                    type={showPassword.old ? "text" : "password"}
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    className={`remove-focus focus-border w-full h-[40px] mt-1 pr-10 font-normal text-base text-gray-900 leading-[22px] font-redhat rounded-lg peer 
        border border-gray-300 px-3 pt-[12px] pb-2
        focus:border-gold-300 focus:ring-1 focus:ring-gold-300 focus:outline-none shadow-none`}
                                    placeholder=" "
                                />
                                <Label
                                    htmlFor="old-password"
                                    className={`absolute left-3 font-normal font-redhat transition-all transform bg-white-50 px-1 pointer-events-none
        ${oldPassword || oldPassword.length > 0 ? "-top-[8px] text-xs leading-[16px] text-gray-700" : "top-4 text-base leading-[22px] text-gray-500 peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:leading-[22px] peer-placeholder-shown:text-gray-500 peer-focus:-top-[8px] peer-focus:text-xs peer-focus:leading-[16px] peer-focus:text-gray-700"}`}
                                >
                                    Old Password
                                </Label>

                                <button
                                    type="button"
                                    onClick={() => toggleVisibility("old")}
                                    className="absolute right-3 top-1 text-gray-500 py-2"
                                >
                                    {showPassword.old ? <EyeOff className="w-[21.07px] h-[18.05px]" /> : <Eye className="w-[21.07px] h-[18.05px]" />}
                                </button>
                            </div>
                            <div className="relative">
                                <Input
                                    id="new-password"
                                    type={showPassword.new ? "text" : "password"}
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    onFocus={() => setShowRequirements(true)}
                                    onBlur={() => setShowRequirements(false)}
                                    className={`remove-focus focus-border w-full h-[40px] mt-1 pr-10 font-normal text-base text-gray-900 leading-[22px] font-redhat rounded-lg peer 
                                        border border-gray-300 px-3 pt-[12px] pb-2
                                        focus:border-gold-300 focus:ring-1 focus:ring-gold-300 focus:outline-none shadow-none`}
                                    placeholder=" "
                                />
                                <Label
                                    htmlFor="old-password"
                                    className={`absolute left-3 font-normal font-redhat transition-all transform bg-white-50 px-1 pointer-events-none
        ${newPassword || newPassword.length > 0 ? "-top-[8px] text-xs leading-[16px] text-gray-700" : "top-4 text-base leading-[22px] text-gray-500 peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:leading-[22px] peer-placeholder-shown:text-gray-500 peer-focus:-top-[8px] peer-focus:text-xs peer-focus:leading-[16px] peer-focus:text-gray-700"}`}
                                >
                                    New Password
                                </Label>

                                <button
                                    type="button"
                                    onClick={() => toggleVisibility("new")}
                                    className="absolute right-3 top-1 text-gray-500 py-2"
                                >
                                    {showPassword.new ? <EyeOff className="w-[21.07px] h-[18.05px]" /> : <Eye className="w-[21.07px] h-[18.05px]" />}
                                </button>
                            </div>
                            {(showRequirements || Object.values(passwordChecks).some(Boolean)) && (
                                <div className="mt-2 w-full rounded-lg">
                                    <p className="text-xs font-normal text-primary-0 leading-4 mb-1">Password must include:</p>
                                    <div className="grid grid-cols-2 gap-x-4  max-w-[350px] text-xs leading-4 font-medium font-redhat">
                                        {[
                                            { key: "length", Label: "Minimum 8 characters" },
                                            { key: "specialChar", Label: "1 Special character" },
                                            { key: "upperLower", Label: "1 upper & lowercase letter" },
                                            { key: "number", Label: "1 Number" },
                                        ].map(({ key, Label }) => (
                                            <div key={key} className="w-full sm:w-full flex items-center gap-1 whitespace-nowrap">
                                                <div className={`w-[10.75px] h-[10.75px] min-w-[10.75px] min-h-[10.75px] rounded-full  flex items-center justify-center transition-all duration-500 ease-in-out transform ${passwordChecks[key] ? "border-gold-200 bg-gold-200" : "border-gray-400 border bg-white-50"}`}>
                                                    {passwordChecks[key] && <Check size={10} className="text-white-50 transition-opacity duration-500 ease-in-out opacity-100 w-[10px]" />}
                                                </div>
                                                <span className={`text-xs leading-4 font-medium transition-colors duration-500 ease-out ${passwordChecks[key] ? "text-gold-300" : "text-gray-400"}`}>
                                                    {Label}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* Confirm New Password Field */}
                        <div className={`${showRequirements ? "mt-5 sm:mt-4" : "mt-5 sm:mt-4"} sm:mt-0 relative`}>
                            <Input
                                ref={confirmPasswordRef}
                                id="confirm-password"
                                type={showPassword.confirm ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                onFocus={() => {
                                    if (showRequirements) {
                                        setShowRequirements(false); // Close div
                                        setTimeout(() => confirmPasswordRef.current?.focus(), 0); // Restore focus after closing
                                    }
                                }}
                                className={`remove-focus focus-border w-full h-[40px] mt-1 pr-10 font-normal text-base text-gray-900 leading-[22px] font-redhat rounded-lg peer 
                                    border border-gray-300 px-3 pt-[12px] pb-2
                                    focus:border-gold-300 focus:ring-1 focus:ring-gold-300 focus:outline-none shadow-none`}
                                placeholder=" " /* Space is needed to keep focus behavior */
                            />
                            <Label
                                htmlFor="old-password"
                                className={`absolute left-3 font-normal font-redhat transition-all transform bg-white-50 px-1 pointer-events-none
        ${confirmPassword || confirmPassword.length > 0 ? "-top-[8px] text-xs leading-[16px] text-gray-700" : "top-4 text-base leading-[22px] text-gray-500 peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:leading-[22px] peer-placeholder-shown:text-gray-500 peer-focus:-top-[8px] peer-focus:text-xs peer-focus:leading-[16px] peer-focus:text-gray-700"}`}
                            >
                                Confirm New Password
                            </Label>
                            <button
                                type="button"
                                onClick={() => toggleVisibility("confirm")}
                                className="absolute right-3 top-1 text-gray-500 py-2"
                            >
                                {showPassword.confirm ? <EyeOff className="w-[21.07px] h-[18.05px]" /> : <Eye className="w-[21.07px] h-[18.05px]" />}
                            </button>
                        </div>
                    </div>
                    <div className="hidden sm:block w-[calc(100%+48px)] mx-[-24px] border-t border-gray-100 mt-5 mb-5"></div>
                    <div>
                        <DialogFooter>
                            <div className="flex flex-col-reverse sm:flex-row w-full gap-4 sm:gap-0 space-y-4 sm:space-y-0 sm:space-x-4 mt-auto pb-6">
                                <DialogTrigger asChild className="w-full sm:w-1/2">
                                    <Button variant="outline" className="text-gold-300 rounded-full text-base leading-5 font-semibold font-redhat hover:bg-transparent hover:text-white-50 hover:bg-gold-300">
                                        Cancel
                                    </Button>
                                </DialogTrigger>
                                <Button
                                    onClick={handleDone}
                                    className={`w-full sm:w-1/2 text-white-50 text-base leading-5 font-semibold font-redhat rounded-full transition-colors duration-300 
        ${Object.values(passwordChecks).every(Boolean) ? "bg-gold-300 hover:bg-gold-400" : "bg-gray-400 hover:bg-gray-500"}
        `}
                                    disabled={!Object.values(passwordChecks).every(Boolean)}
                                >
                                    Done
                                </Button>
                            </div>
                        </DialogFooter>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
};
export default UpdatePasswordModal;
